import React from "react";
import { Typography } from "@mui/material";
import colorsCustom from "../../designTokens/colorsCustom";
import PropTypes from "prop-types";

export const ThreadTitle = ({ 
  children, 
  isMobile = false,
  variant,
  sx = {},
  ...props 
}) => {
  const baseStyles = {
    fontWeight: 900,
    fontFamily: '"source-han-serif-korean", serif',
    color: colorsCustom.ui.dark.bold,
    marginBottom: isMobile ? 3 : 8,
    // 반응형 폰트 사이즈와 줄간격
    lineHeight: isMobile ? 1.4 : 1.3, // 상대적 줄간격으로 설정
    wordBreak: "keep-all", // 한국어 단어 단위로 줄바꿈
    overflowWrap: "break-word", // 긴 단어 줄바꿈 허용
    ...sx
  };

  return (
    <Typography
      variant={variant || (isMobile ? "h6" : "h5")}
      sx={baseStyles}
      {...props}
    >
      {children}
    </Typography>
  );
};

ThreadTitle.propTypes = {
  children: PropTypes.node.isRequired,
  isMobile: PropTypes.bool,
  variant: PropTypes.string,
  sx: PropTypes.object,
};